import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import { ServicesList, ServiceDetail } from "@/pages/Services";
import { CitiesList, CityDetail } from "@/pages/Cities";
import About from "@/pages/About";
import Insights, { InsightDetail } from "@/pages/Insights";
import { CaseStudiesList, CaseStudyDetail } from "@/pages/CaseStudies";
import { SeoIndex, SeoLanding } from "@/pages/SeoLanding";
import Contact from "@/pages/Contact";
import { LangSync } from "@/context/LanguageContext";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <LangSync />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesList />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/cities" element={<CitiesList />} />
              <Route path="/cities/:slug" element={<CityDetail />} />
              <Route path="/case-studies" element={<CaseStudiesList />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/seo" element={<SeoIndex />} />
              <Route path="/seo/:slug" element={<SeoLanding />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              {/* French (fr-CA) versions — hreflang-paired with their English twins */}
              <Route path="/fr" element={<Home />} />
              <Route path="/fr/services" element={<ServicesList />} />
              <Route path="/fr/services/:slug" element={<ServiceDetail />} />
              <Route path="/fr/cities/:slug" element={<CityDetail />} />
              <Route path="/fr/seo" element={<SeoIndex />} />
              <Route path="/fr/seo/:slug" element={<SeoLanding />} />
              <Route path="/fr/about" element={<About />} />
              <Route path="/fr/contact" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
